export const initSortUpcoming = () => {
    const mapUpcoming = document.querySelector('.js-map-upcoming'),
        markerInspections = document.querySelectorAll('.js-inspection');

    if (mapUpcoming && markerInspections.length > 0) {
        const sortCards = (refNumber) => {
            const container = document.querySelector('js-card-upcoming');
            const sortCard = document.querySelector(`[data-card-id="${refNumber}"]`)
            sortCard.parentNode.prepend(sortCard);
        }

        markerInspections.forEach((markerInsMarker) => {
            markerInsMarker.addEventListener('click', event => {
                sortCards(markerInsMarker.getAttribute('data-id'));
            });
            
        });

    }
}